<div class="modal-header">
  <h4 class="modal-title">{{'CHANGE_INVOICE' | translate}}</h4>
</div>
<div class="modal-body">
  <div>
    <select [(ngModel)]="invoice.service_price_id" class="w-100">
      <option *ngFor="let c of servicePrices" [ngValue]="c.id">{{c.service_name}} {{c.length_text | translate}}
        {{c.price | money}}</option>
    </select>
  </div>
</div>
<div class="modal-footer text-center">
  <dx-button id="check" type="success" icon="check" useSubmitBehavior="true" (onClick)="ok(invoice)">
  </dx-button>

  <dx-button id="close" icon="close" type="normal" (onClick)="activeModal.dismiss('cancel click')">
  </dx-button>
</div>